import React from 'react'
import {
  Breadcrumbs,
  Button,
  SearchWithFilter,
  type FilterSelection,
} from '@enamelai/design-system'
import './PatientFormsViewTopBar.css'

const FILTER_LABELS = {
  date: 'Date',
  tag: 'Tag',
}

type PatientFormsViewTopBarProps = {
  patientName: string
  appointmentName?: string
  onBack: () => void
  searchQuery: string
  onSearch: (value: string) => void
  filters: FilterSelection
  onFilterChange: (filters: FilterSelection) => void
  onResetFilters: () => void
  filterSelectionList: { date: string[]; tag: string[] }
  onCreateForm: () => void
}

const PatientFormsViewTopBar: React.FC<PatientFormsViewTopBarProps> = ({
  patientName,
  appointmentName,
  onBack,
  searchQuery,
  onSearch,
  filters,
  onFilterChange,
  onResetFilters,
  filterSelectionList,
  onCreateForm,
}) => {
  const hasFilterOptions = Object.values(filterSelectionList).some(
    (options) => options.length > 0,
  )

  const breadcrumbItems = [
    { id: 'patient', label: patientName, onClick: onBack },
    { id: 'completed-forms', label: 'Completed forms', onClick: onBack },
    ...(appointmentName ? [{ id: 'appointment', label: appointmentName }] : []),
  ]

  return (
    <div className="pfv-top-row">
      <Breadcrumbs
        className="pfv-breadcrumbs"
        items={breadcrumbItems}
        showBackIcon
        onBackClick={onBack}
      />
      <div className="pfv-top-row-right">
        <SearchWithFilter
          className="pfv-search-filter"
          placeholder="Search forms..."
          ariaLabel="Search forms"
          value={searchQuery}
          onChange={onSearch}
          onClear={() => onSearch('')}
          filters={filterSelectionList}
          filterLabels={FILTER_LABELS}
          selectedFilters={filters}
          onFilterChange={onFilterChange}
          onReset={onResetFilters}
          showFilter={hasFilterOptions}
          showResetButton={hasFilterOptions}
        />
        <Button
          variant="primary"
          size="md"
          type="button"
          onClick={onCreateForm}
        >
          Create form
        </Button>
      </div>
    </div>
  )
}

export default PatientFormsViewTopBar
